import React from "react";
import { Route, Routes } from "react-router-dom";
import TrsRastreoMainPage from "../pages/TrsRastreoMainPage";
import TrsRastreoUsuariosPage from "../pages/TrsRastreoUsuariosPage";
import TrsRastreoVehiculosPage from "../pages/TrsRastreoVehiculosPage";
import TrsRastreoGruposPage from "../pages/TrsRastreoGruposPage";

const TrsRastreoRoutes = () => {
  return (
    <Routes>
      <Route index element={<TrsRastreoMainPage />} />
      <Route path="usuarios" element={<TrsRastreoUsuariosPage />} />
      <Route path="vehiculos" element={<TrsRastreoVehiculosPage />} />
      <Route path="grupos" element={<TrsRastreoGruposPage />} />
      <Route path="*" element={<TrsRastreoMainPage />} />
    </Routes>
  );
};

export default TrsRastreoRoutes;
